import { Box, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ui } from "../i18n";
import { LayoutState, LayoutTextMarginTopLarge, LayoutTextMarginTopMedium, MediaQueryLinebreak, MediaQueryMobile, MediaQueryShallow, ScrollToPosition } from "../Layout";
import { change } from "../state/Nav";
import { RootState } from "../store";
import { TextBody, TextBox, TextHeader } from "../Styles";
import { hideKrpano } from "../Util";

export default function About() {
    // Init layout parameters
    const layoutState = new LayoutState();
    layoutState.isMobile = useMediaQuery(MediaQueryMobile);
    layoutState.isShallow = useMediaQuery(MediaQueryShallow);
    layoutState.linebreak = useMediaQuery(MediaQueryLinebreak);
 
    // Determine UI language
    const lang = useSelector((state: RootState) => state.language.value);

    // Set navigation to current component
    const dispatch = useDispatch();
    dispatch(change("about"));

    // Hide virtual tour
    hideKrpano();

    // Scroll to previous position
    ScrollToPosition("about");
          
    return (
        <Box sx={{ paddingBottom: layoutState.LayoutPaddingBottom(), paddingTop: layoutState.paddingTop() }}>
            <TextBox>
                <TextHeader>
                    {ui[lang].About.artspace}
                </TextHeader>
                <TextBody>
                    {ui[lang].About.artspacebody}
                </TextBody>
                <TextHeader marginTop={LayoutTextMarginTopLarge}>
                    {ui[lang].About.venue}
                </TextHeader>
                <TextBody>
                    {ui[lang].About.venuebody1}
                </TextBody>
                <TextBody marginTop={LayoutTextMarginTopMedium}>
                    {ui[lang].About.venuebody2}
                </TextBody>
            </TextBox>
        </Box>
    );
}